import { get, post } from '@/request/http';

const LoanSupermarket = {
  // 获取banner
  getBannerInfo() {
    return post(
      '/backloansuper/loan/supermarket/banner/bff/getBannerInfo?location=0',
    );
  },
  // 获取产品列表
  productList(params) {
    return get(
      `/backloansuper/loan/supermarket/product/bff/productList?districtId=${params.districtId
        || ''}&seq=${params.seq || 0}&pageSize=50&pageNum=1`,
    );
  },
  // 获取产品列表
  conditionProductList(params) {
    return post('/backloansuper/loan/supermarket/queryFilterProductList/v1.0', params);
  },
  // 更新order
  getUnfinishedOrder() {
    return post('/backloansuper/loan/supermarket/getUnfinishedOrder');
  },
  // 获取getLocationInfo
  getLocationInfo(params) {
    return get(
      `/backloansuper/loan/supermarket/getLocationInfo?lat=${params.lat}&lng=${params.lng}`,
    );
  },
  getTicketInfo(Url) {
    // 微信地址获取
    return get(`/backloansuper/loan/supermarket/getTicketInfo?requestUrl=${Url}`);
  },
  // 光大银行 之间的跳转
  encapsulationAxios() {
    return post('/backloansuper/loan/supermarket/order/recordCreditCard');
  },
  // 光大银行 之间的跳转
  queryFilterCondition(params) {
    return post('/backloansuper/loan/supermarket/queryFilterCondition/v1.0', params);
  },
  loanTestAmount() {
    return post('/backloansuper/loan/supermarket/test/loanTestAmount', {
      customerSource: 1,
      activityType: 1,
    });
  },
  saveDrawImage(params) {
    return post('/backloansuper/loan/supermarket/saveDrawImage/v1.0', params);
  },
  queryDrawImage(drawId) {
    return post('/backloansuper/loan/supermarket/queryDrawImage/v1.0', {
      drawId,
    });
  },

};
export default LoanSupermarket;
